import React from 'react'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import classNames from 'classnames'
import { useLocation } from 'react-router'

const PaginationControl: React.FC<{
  index: number
  total: number
  prev?: boolean
  next?: boolean
  children?: React.ReactElement | string
  className?: string
  value: number
  queryMode?: boolean
  queryKey?: string
  onChange?: (current: number) => any
}> = ({
  index,
  prev,
  next,
  children,
  className,
  value,
  queryMode = true,
  queryKey = 'page',
  total,
  onChange
}): React.ReactElement => {
  const location = useLocation()
  const state = React.useMemo<{
    Tag: React.ElementType | typeof Link
    disabled: boolean
  }>(() => {
    let Tag: React.ElementType | typeof Link = queryMode ? Link : 'a'
    let disabled = false

    if (index === value) {
      disabled = true
      Tag = 'a'
    } else if (prev && index < 1) {
      disabled = true
      Tag = 'a'
    } else if (next && index > total) {
      disabled = true
      Tag = 'a'
    }

    return { Tag, disabled }
  }, [queryMode, value])

  const to = React.useMemo<string>(() => {
    const { Tag, disabled } = state
    let to = ''

    if (Tag !== 'a' && !disabled) {
      const parsed = queryString.parse(location.search)

      parsed[queryKey] = index + ''

      to = `?${queryString.stringify(parsed)}`
    }

    return to
  }, [state])

  const { Tag, disabled } = state

  const handleClick = (index: number) => {
    if (!disabled) {
      onChange?.(index)
    }
  }

  return (
    <Tag
      to={to}
      onClick={() => handleClick(index)}
      role={!to ? 'button' : undefined}
      className={classNames('pagination-control', className, {
        _disabled: disabled
      })}
    >
      {children}
    </Tag>
  )
}

export default PaginationControl
